/**
 * Shared styling utilities for feature flags
 */

import { StyleSheet } from 'react-native';
import { ADMIN_COLORS } from '@/constants/admin';

/**
 * Get value badge style based on current value and default value
 */
export const getValueStyle = (currentValue: any, defaultValue: any) => {
  if (currentValue === defaultValue) {
    return styles.valueBadgeDefault;
  }
  if (typeof currentValue === 'boolean') {
    return currentValue ? styles.valueBadgeTrue : styles.valueBadgeFalse;
  }
  return styles.valueBadgeCustom;
};

export const styles = StyleSheet.create({
  valueBadge: {
    alignSelf: 'flex-start',
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 12,
  },
  valueBadgeDefault: {
    backgroundColor: ADMIN_COLORS.PRIMARY + '33',
  },
  valueBadgeTrue: {
    backgroundColor: ADMIN_COLORS.SUCCESS + '33',
  },
  valueBadgeFalse: {
    backgroundColor: ADMIN_COLORS.ERROR + '33',
  },
  valueBadgeCustom: {
    backgroundColor: ADMIN_COLORS.WARNING + '33',
  },
  valueBadgeText: {
    fontSize: 12,
    fontWeight: '500',
    color: ADMIN_COLORS.TEXT.PRIMARY,
  },
});

